<template>
  <div v-show="showTable">
    <!-- 1. 使用 flex 布局包裹标题和按钮 -->
    <div style="display: flex; align-items: center; justify-content: space-between;">
      <div style="font-size: 0.8em; font-weight: bold;">备注提取</div>
      <!-- 2. 添加复制按钮，并将 tableInstance 作为 prop 传入 -->
      <copy-table-button size="small" style="border-radius: 15px" :table="tableInstance"/>
    </div>

    <el-table
        :data="localRemarks"
        :show-header="false"
        style="width: 100%; margin-top: 10px"
        :key="tableKey"
        ref="remarksTableRef"
    >
      <el-table-column type="index" width="50" align="center"/>
      <el-table-column prop="value" label="备注信息" min-width="140" style="font-size: 0.8em">
        <template #default="{ row }">
          <!-- 根据编辑状态显示 span 或 textarea -->
          <span v-if="!row.isEditing">{{ row.value }}</span>
          <el-input
              v-else
              v-model="row.editValue"
              type="textarea"
              :autosize="{ minRows: 2 }"
          />
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150" align="center">
        <template #default="{ row }">
          <!-- 非编辑状态的按钮 -->
          <div v-if="!row.isEditing">
            <el-button size="small" type="primary" link @click="handleEdit(row)">修改</el-button>
            <el-button size="small" type="primary" link @click="handleLocate(row)">定位</el-button>
          </div>
          <!-- 编辑状态的按钮 -->
          <div v-else>
            <el-button size="small" type="success" @click="handleConfirm(row)">确认</el-button>
            <el-button size="small" @click="handleCancel(row)">取消</el-button>
          </div>
        </template>
      </el-table-column>
      <template #empty>
        <div style="padding: 20px; color: #909399;">暂无备注信息</div>
      </template>
    </el-table>
  </div>
</template>

<script>
// 1. 导入 CopyTableButton 组件
import CopyTableButton from "@/components/sub_component/copyTableButton.vue";
import {ElMessage} from 'element-plus';
import {mapState} from "vuex";
import {showRowBoxImg} from "@/components/file_process_js/ function_process/vision_box_process";
import store from "@/store";
import {locationByPathKeyword} from "@/components/file_process_js/utils";

export default {
  name: 'TextParamTable',
  // 2. 注册组件
  components: {
    CopyTableButton
  },
  props: {
    fileInfo: {
      type: Object,
      required: true
    },
    positionKey: {type: String, required: true}
  },
  data() {
    return {
      localRemarks: [],
      showTable: false,
      lastFileInfoStatusCode: 0,
      tableKey: 0,
      tableInstance: null // 3. 用于存放表格实例
    };
  },
  computed: {
    ...mapState(['checkListChangeSign']),
  },
  watch: {
    'fileInfo.position_params': {
      immediate: true,
      deep: false,
      handler(newVal) {
        this.refreshTable()
      }
    },
    checkListChangeSign(currentSign) {
      if (currentSign && this.lastFileInfoStatusCode !== this.fileInfo.status_code) {
        console.log("table start refresh");
        this.refreshTable()
      }
    }
  },
  // 4. 在 mounted 钩子中获取表格实例
  mounted() {
    this.$nextTick(() => {
      this.tableInstance = this.$refs.remarksTableRef;
    });
  },
  methods: {
    refreshTable() {
      this.localRemarks = [];
      const position_params = this.fileInfo.position_params
      this.lastFileInfoStatusCode = this.fileInfo.status_code
      if (!position_params || !position_params[this.positionKey] || !position_params[this.positionKey].textParams) {
        // 如果没有数据，确保表格是隐藏的
        this.showTable = false;
        return;
      }
      const sourceParams = position_params[this.positionKey].textParams;
      // 重置 showTable 状态
      this.showTable = false;

      let hasData = false;
      for (let i = 0; i < sourceParams.length; i++) {
        if (sourceParams[i].res && sourceParams[i].res.length > 0) {
          hasData = true;
          sourceParams[i].res.forEach((resItem) => {
            this.transformData(resItem)
            this.localRemarks.push(resItem);
          })
        }
      }

      // 仅当有有效数据时才显示表格
      if (hasData) {
        this.showTable = true;
      }

      this.tableKey += 1
    },

    transformData(row) {
      row.isEditing = row.isEditing || false
    },
    handleEdit(row) {
      row.isEditing = true;
      row.editValue = row.value;
    },
    async handleConfirm(row) {
      row.value = row.editValue;
      row.isEditing = false;
      ElMessage.success("备注修改成功");
      console.log("textParam fileInfo", this.fileInfo);
      await store.dispatch("fileCheckListLevelChange")
    },
    handleCancel(row) {
      row.isEditing = false;
    },
    async handleLocate(row) {
      console.log(`准备定位表格行:`, row, this.fileInfo, row, row.keyword);
      await locationByPathKeyword(this.fileInfo.file_path, row.keyword)
      // showRowBoxImg(row, this.fileInfo.project_id, this.fileInfo.vision_ratio);
    }
  }
};
</script>